__turbopack_context__.v({
  "authorArticlesHeader": "AuthorProfileSec1-module__GlzhXq__authorArticlesHeader",
  "authorArticlesTitle": "AuthorProfileSec1-module__GlzhXq__authorArticlesTitle",
  "authorAvatar": "AuthorProfileSec1-module__GlzhXq__authorAvatar",
  "authorAvatarWrap": "AuthorProfileSec1-module__GlzhXq__authorAvatarWrap",
  "authorBioCard": "AuthorProfileSec1-module__GlzhXq__authorBioCard",
  "authorBioContent": "AuthorProfileSec1-module__GlzhXq__authorBioContent",
  "authorBioHeading": "AuthorProfileSec1-module__GlzhXq__authorBioHeading",
  "authorBioText": "AuthorProfileSec1-module__GlzhXq__authorBioText",
  "authorMainTitle": "AuthorProfileSec1-module__GlzhXq__authorMainTitle",
  "authorProfileContainer": "AuthorProfileSec1-module__GlzhXq__authorProfileContainer",
  "authorProfileSection": "AuthorProfileSec1-module__GlzhXq__authorProfileSection",
  "blogGrid": "AuthorProfileSec1-module__GlzhXq__blogGrid",
  "loadMoreBtn": "AuthorProfileSec1-module__GlzhXq__loadMoreBtn",
  "loadMoreWrap": "AuthorProfileSec1-module__GlzhXq__loadMoreWrap",
  "loadingGif": "AuthorProfileSec1-module__GlzhXq__loadingGif",
  "loadingWrapBottom": "AuthorProfileSec1-module__GlzhXq__loadingWrapBottom",
  "travelInsightArrowBtn": "AuthorProfileSec1-module__GlzhXq__travelInsightArrowBtn",
  "travelInsightBody": "AuthorProfileSec1-module__GlzhXq__travelInsightBody",
  "travelInsightCard": "AuthorProfileSec1-module__GlzhXq__travelInsightCard",
  "travelInsightCardDescription": "AuthorProfileSec1-module__GlzhXq__travelInsightCardDescription",
  "travelInsightCardImage": "AuthorProfileSec1-module__GlzhXq__travelInsightCardImage",
  "travelInsightCardTitle": "AuthorProfileSec1-module__GlzhXq__travelInsightCardTitle",
  "travelInsightCategoryIcon": "AuthorProfileSec1-module__GlzhXq__travelInsightCategoryIcon",
  "travelInsightCategoryTag": "AuthorProfileSec1-module__GlzhXq__travelInsightCategoryTag",
  "travelInsightDateBadge": "AuthorProfileSec1-module__GlzhXq__travelInsightDateBadge",
  "travelInsightFooter": "AuthorProfileSec1-module__GlzhXq__travelInsightFooter",
  "travelInsightImageWrap": "AuthorProfileSec1-module__GlzhXq__travelInsightImageWrap",
  "travelInsightMetaLeft": "AuthorProfileSec1-module__GlzhXq__travelInsightMetaLeft",
  "travelInsightShareBtn": "AuthorProfileSec1-module__GlzhXq__travelInsightShareBtn",
  "travelInsightViews": "AuthorProfileSec1-module__GlzhXq__travelInsightViews",
});
